import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ConfigurationService } from '@core/services';
import { UserClaims } from '@okta/okta-auth-js';
import { firstValueFrom, Observable } from 'rxjs';
import { OktaIntegrationService } from '../../services/okta-integration.service';

@Component({
  standalone: false,
  selector: 'app-okta-container',
  templateUrl: './okta-container.component.html',
  styleUrls: ['./okta-container.component.scss'],
})
export class OktaContainerComponent implements OnInit {
  @Input() text: string;
  @Output() patronEmmiter: EventEmitter<UserClaims> = new EventEmitter();

  patron: UserClaims;
  patronName: string;
  isAuthenticated$!: Observable<boolean>;
  isAuthenticated: boolean = false;

  private _oktaService = inject(OktaIntegrationService);
  public configurationService = inject(ConfigurationService);

  async ngOnInit(): Promise<void> {
    this.isAuthenticated$ = this._oktaService.getIsAuthenticated();
    if (await firstValueFrom(this.isAuthenticated$)) {
      this.isAuthenticated = true;
      this.patron = await this._oktaService.getUserInfo();
      this.patronName = this.patron?.name ?? 'Patron name not found';

      this.patronEmmiter.emit(this.patron);
    }
  }

  async signInRedirect(): Promise<void> {
    let origin = window.location.href;
    await this._oktaService.signInWithRedirect(origin, 'okta/redirect');
    const isAuthenticated = await firstValueFrom(
      this._oktaService.getIsAuthenticated()
    );
    if (isAuthenticated) {
      this.isAuthenticated = true;
      this.patron = await this._oktaService.getUserInfo();
      this.patronName = this.patron?.name ?? 'Patron name not found';
      this.patronEmmiter.emit(this.patron);
    }
  }

  async signOut(): Promise<void> {
    let origin = window.location.origin;
    await this._oktaService.signOut(origin);
    this.isAuthenticated = false;
    this.patron = undefined as unknown as UserClaims;
    this.patronName = '';
    this.patronEmmiter.emit(this.patron);
  }
}
